export const MEETING_DATA_REQ = "MEETING_DATA_REQ";
export const MEETING_DATA_SUCCESS = "MEETING_DATA_SUCCESS";
export const MEETING_DATA_FAILED = "MEETING_DATA_FAILED";
